import React, { createContext, useContext } from 'react'
import mapboxgl from 'mapbox-gl'

interface MapboxMapContextValue {
  map: React.MutableRefObject<mapboxgl.Map | null>
  isLoaded: boolean
  styleLoaded: boolean
}

const MapboxMapContext = createContext<MapboxMapContextValue | null>(null)

export function useMapboxMapContext() {
  const context = useContext(MapboxMapContext)
  if (!context) {
    throw new Error('useMapboxMapContext must be used within MapboxMapProvider')
  }
  return context
}

interface MapboxMapProviderProps {
  map: React.MutableRefObject<mapboxgl.Map | null>
  isLoaded: boolean
  styleLoaded: boolean
  children: React.ReactNode
}

export function MapboxMapProvider({
  map,
  isLoaded,
  styleLoaded,
  children
}: MapboxMapProviderProps) {
  return (
    <MapboxMapContext.Provider value={{ map, isLoaded, styleLoaded }}>
      {children}
    </MapboxMapContext.Provider>
  )
}

